import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'red' | 'white';
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  variant = 'red',
  href = '#offer'
}: CTAButtonProps) {
  const colors = variant === 'red' ? 'bg-brand-red text-white hover:bg-[#d73939] focus-visible:ring-brand-red' : 'bg-white text-brand-red hover:bg-brand-main focus-visible:ring-white';
  return <a href={href} className={`cta-attention inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 text-sm font-extrabold tracking-wide shadow-md transition duration-300 hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 md:text-base ${colors} ${className}`} data-id="element-246">
      {children}
      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-247" />
    </a>;
}